<template>
	<div class="cdkey-page">
		<div class="content">
			<el-row class="logo-row">
				<div class="logo">
					<!-- <img src="../../../../public/images/itclogo.png" alt="itclogo" /> -->
				</div>
				<h2>{{$t('cdkey.systemOverdue')}}</h2>
				<p>{{$t('cdkey.getRegistrationKey')}}</p>
			</el-row>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="($i18n.locale === 'en-us' ? '150' : '70') + 'px'" class="cdkey-rorm">
				<el-form-item :label="$t('cdkey.serialNumber')" prop=""><el-input v-model="ruleForm.uuid" readonly :placeholder="$t('cdkey.placeholder1')"></el-input></el-form-item>
				<el-form-item :label="$t('cdkey.RegistrationCode')" prop="passnum" class="code-form-item">
					<el-input v-model.trim="ruleForm.passnum" :placeholder="$t('cdkey.placeholder2')"></el-input>
				</el-form-item>
				<el-form-item class="send-item"><el-button type="primary" @click="submitForm('ruleForm')">{{$t('cdkey.activation')}}</el-button></el-form-item>
			</el-form>
		</div>
		<el-dialog title="" class="tips-dialog" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
			<div class="part1">
				<p class="part-name">{{$t('cdkey.partTime')}}</p>
				<div class="time-tips" v-if="resData.start_time != resData.end_time">{{ resData.start_time }} ~ {{ resData.end_time }}</div>
				<div class="time-tips" v-else>{{ $t('cdkey.InfiniteDays')}}</div>
			</div>
			<div class="part2">
				<p class="part-name">{{$t('cdkey.partModel')}}</p>
				<div>
					<span class="tit">{{$t('cdkey.android')}}</span>
					<el-radio-group v-model="resData.android" size="small">
						<el-radio label="1">{{$t('cdkey.OnActivation')}}</el-radio>
						<el-radio label="0">{{$t('cdkey.UnActivation')}}</el-radio>
					</el-radio-group>
				</div>
				<div>
					<span class="tit">IOS</span>
					<el-radio-group v-model="resData.ios" size="small">
						<el-radio label="1">{{$t('cdkey.OnActivation')}}</el-radio>
						<el-radio label="0">{{$t('cdkey.UnActivation')}}</el-radio>
					</el-radio-group>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			ruleForm: {
				uuid: '',
				passnum: ''
			},
			rules: {
				passnum: [
					{
						required: true,
						message: this.$t('cdkey.message'),
						trigger: 'blur'
					}
				]
			},
			dialogVisible: false,
			resData: {}
		};
	},
	watch: {},
	created() {
		this.getCode();
		this.checkGetauth();
	},
	methods: {
		// 系统过期问题，未过期跳回首页
        checkGetauth() {
			let success = res => {
				if(res.data === 'yes') {
					let host_addr = sessionStorage.getItem('host_addr')
					// window.location.href = host_addr
				}
			};
			let fail = res => {};
			this.$ajax.get('/api/login/getauth', {
				params: {},
				func: { success, fail }
			});
        },
		getCode() {
			let success = res => {
				this.ruleForm.uuid = res.data;
			};
			let fail = res => {};
			this.$ajax.get('/index/checkpass/get_uuid2', {
				params: {},
				func: { success: success, fail: fail }
			});
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.send();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		send() {
			let success = res => {
				this.$message.success(this.$t('cdkey.activationSuccess'));
				this.resData = res.data;
				this.dialogVisible = true;
				setTimeout(() => {
					this.dialogVisible = false;
					// this.$router.push('/');
					let host_addr = sessionStorage.getItem('host_addr')
					window.location.href = host_addr
				}, 3000);
			};
			let fail = res => {
				this.$message.error(this.$t('cdkey.activationFail'));
			};
			this.$ajax({
				url: '/index/checkpass/auto_pass',
				method: 'post',
				data: this.ruleForm,
				func: {
					success: success,
					fail: fail
				}
			});
		}
	}
};
</script>

<style lang="scss">
.cdkey-page {
	height: calc(100vh - 44px);
	display: grid;
	justify-content: center;
	align-content: center;
	.content {
		background-color: #fff;
		border-radius: 8px;
		padding: 30px 60px 50px;
		box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
		.logo-row {
			.logo {
				text-align: center;
				img {
					width: 120px;
				}
			}
			h2 {
				font-size: 22px;
				font-weight: bold;
				line-height: 22px;
				padding: 40px 0 20px;
			}
			p {
				font-size: 14px;
				line-height: 20px;
				color: #999;
				word-wrap: break-word; 
				width: 500px;
			}
		}
		.cdkey-rorm {
			width: 500px;
			padding-top: 25px;

			.send-item {
				padding-top: 20px;
				.el-button {
					width: 100%;
					height: 40px;
					padding: 0;
				}
			}
		}
	}
	.el-dialog__headerbtn .el-dialog__close {
		font-size: 28px;
		color: #409eff;
	}
	.tips-dialog {
		.part1 {
			padding-bottom: 20px;
		}
		.part-name {
			font-size: 18px;
			font-weight: bold;
		}
		.tit {
			font-size: 16px;
			line-height: 22px;
		}
		.time-tips,
		.el-radio-group {
			padding: 20px 40px;
		}
	}
}
</style>
